"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT = exports.CONTACT_ALL = exports.QUOTE_ALL = exports.CLOUD_SITE = exports.APPROVAL_DESK_ALL = exports.REFUND_ALL = exports.INVOICE_ALL = exports.ENTITLEMENT_ALL = exports.SHIP_TO_PARTY_ALL = exports.BILL_TO_PARTY_ALL = exports.INVOICE_GROUP_ALL = exports.TRANSACTION_ACCOUNT_ALL = void 0;
exports.TRANSACTION_ACCOUNT_ALL = 'transaction-account/all';
exports.INVOICE_GROUP_ALL = 'invoice-group/all';
exports.BILL_TO_PARTY_ALL = 'bill-to-party/all';
exports.SHIP_TO_PARTY_ALL = 'ship-to-party/all';
exports.ENTITLEMENT_ALL = 'entitlement/all';
exports.INVOICE_ALL = 'invoice/all';
exports.REFUND_ALL = 'refund/all';
exports.APPROVAL_DESK_ALL = 'approvaldesk/all';
exports.CLOUD_SITE = 'entitlement/cloudsite';
exports.QUOTE_ALL = 'quote/all';
exports.CONTACT_ALL = 'contact/all';
exports.DEFAULT = 'default';
